import { axiosInstance } from '@configs/axios/axiosInstance';

import type { SfAccount } from '../types/sfRedirect.types';

/**
 * Get Salesforce account details
 * Endpoint: GET /sf-redirect/accounts/{sfAccountId}
 *
 * Always returns 200. The `isOnboarded` flag indicates whether
 * the organization has been imported into CAE Connect.
 */
export async function getSfAccount(sfAccountId: string): Promise<SfAccount> {
  const { data } = await axiosInstance.get<SfAccount>(
    `/sf-redirect/accounts/${encodeURIComponent(sfAccountId)}`
  );
  return data;
}
